import $ from 'jquery';
import { formatRuleInfo } from '../utils/formater'
const host = location.href.indexOf("localhost") != -1 ? '/proxy/' : "/web-detail";
let getFlightRuleInfo;
// const host = location.href.indexOf("localhost") != -1 ? 'http://localhost:5020' : "/web-detail";
const actions = {
    //自由组合数据列表
    freeFlightList(context, payload) {
        //请求参数字段 payload
        // adultCount: 2   成人人数
        // babyCount: 0    婴儿人数
        // backCityCode: 1502    抵达城市码
        // bookCityCode: "1602"  预订城市码
        // channelCount: 3       已返回的渠道个数 第一次传0，后面根据上一次调用返回的数值设值
        // channelRelationId: "010000000000"  渠道（非分销(010000000000)，分销(020110000000） 默认非分销，分销改变去值
        // childCount: 0   儿童人数
        // clientFlag: "MOB-TRAFFIC"  调用方系统标识 默认为：MOB-FLIGHT
        // departCityCode: 1602   出发城市码
        // departsDate: "2021-05-25"   第一程的出发日期
        // flightKey: null    航程组合
        // flightType: 1  机票类型 1单程 2往返 3联程
        // mixType: 2    组合类型 1推荐组合 2自由组合
        // pollTag: 0   轮询标记 0查询 1轮询 （如果轮询，不去渠道补查） 第一次查询传0，后面都传1
        // productId: "210176716"  产品ID
        // ruleFlag: 1  是否根据默认交通规则过滤 1默认条件 0修改了默认条件
        // systemId: 71  系统id
        // v: 155322
        let url = host + '/api/flight/resource/searchFlightInfo';
        // let url = host + '/api/flight/resource';

        context.commit("setShowProgress", true);
        context.commit("setProgressSuccess", false);
        $.ajax({
            type: "get",
            url: url,
            data: payload,
            success: function (data) {
                //展示小飞机进度条

                // let data = response.data;
                //返回数据字段 response.data
                //data

                //--->filtered:数组：兼顾机票页面筛选
                //------------>field:筛选code 例子"transferFlag"
                //------------>name:筛选名称 例子"直飞/中转"
                //------------>items：数组：筛选数据
                //------------------>{code: "0" text: "仅看直飞"}

                //--->flightInlandItemSearchList:数组：航班信息列表
                //------------------------------>inlandConnectionInfoList:数据：航段信息
                //------------------------------>inlandTransferInfoList：中转时长信息
                //------------------------------>还有一些票价，成人数，餐食等字段

                //---->flightInlandPollingCondition:轮询条件
                //-------------------------------->needQueryMore 0：返回部分数据 1：返回全部数据  为1时应停止轮询
                //-------------------------------->channelCount  第一次查询时，请传入0；后面每次轮询时，使用上一次轮询后的出参结果channelCount
                //-------------------------------->retDiffFlag   当此出参为 false：结果无变化（无返回结果）时，返回为空；为true：结果有变化（有返回结果）   时，返回有结果
                //-------------------------------->queryId  查询条件ID
                //-------------------------------->directionId  方向id
               
                //成功请求来数据
                // debugger;
                if (data) {
                    //数组：航班信息列表
                    let flightInlandItemSearchList = data.data.flightInlandItemSearchList;
                    //轮询条件
                    let flightInlandPollingCondition = data.data.flightInlandPollingCondition;
                    //0：返回部分数据 1：返回全部数据  为1时应停止轮
                    let needQueryMore = flightInlandPollingCondition.needQueryMore;
                    let directionId = flightInlandPollingCondition.directionId;
                    context.commit("setDirectionId", directionId);
                    // context.commit("setreloadProgress", false);
                    //继续轮询；循环的时候，空数据不展示
                    if (needQueryMore != 1) {
                        // debugger;
                        //第一次查询时，请传入0；后面每次轮询时，使用上一次轮询后的出参结果channelCount
                        payload.channelCount = flightInlandPollingCondition.channelCount;
                        //请求机票散客票3.0列表接口数据（这里是递归）
                        payload.pollTag = 1;
                        payload.v = parseInt((Math.random() * 1000000).toString());
                        context.dispatch("freeFlightList", payload);
                        //返回的机票列表可能为空，不为空时就是全部已有数据
                        if (flightInlandItemSearchList.length > 0) {
                            context.commit("freeFlight", data);
                            context.commit("setlistNum", flightInlandItemSearchList.length);
                        }
                    } else {
                        // debugger
                        //此时轮询已经结束
                        context.commit("setProgressSuccess", true);
                        //返回的机票列表可能为空，不为空时就是全部已有数据
                        if (flightInlandItemSearchList.length > 0) {
                            context.commit("setLoading", false);
                            context.commit("freeFlight", data);
                            context.commit("setlistNum", flightInlandItemSearchList.length);
                        }
                        //数据为空
                        let freeFlightList = context.getters.getFreeFlight;
                        if (!freeFlightList || JSON.stringify(freeFlightList) == "{}" && freeFlightList.data.flightInlandItemSearchList.length < 1) {
                            context.commit("setErrormsg", true);
                        }
                    }
                } else {
                    let storeFreeFlight = context.getters.getFreeFlight;
                    let flightInlandItemSearchList = storeFreeFlight.data.flightInlandItemSearchList;
                    if(flightInlandItemSearchList.length<=0){
                        context.commit("setErrormsg", true);
                        context.commit("setProgressSuccess", true);
                        console.error("freeFlightList--data:", data);
                    } 
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error("freeFlightList", jqXHR, textStatus, errorThrown);
                context.commit("setErrormsg", true);
                // context.commit("setProgressSuccess", true);
            }
        });
    },
    //自由组合下拉折叠层舱位选择价格
    getFlightAllPriceInfo(context, payload) {
        let url = host + '/api/flight/resource/flightAllPriceInfo';
        // let url = host + '/api/flight/resource/flightAllPriceInfo';
        context.commit("setShowProgress", true);
        context.commit("setProgressSuccess", false);
        $.ajax({
            type: "get",
            url: url,
            data: payload,
            success: function (response) {
                if (response.success) {
                    if (payload.currentIndex == 2 && payload.currentActionCode) {
                        response.data.inlandDetailInfos = response.data.inlandDetailInfos.filter(item=>{
                            if (!item.priceFlightCabinList[0].actionCode || !item.priceFlightCabinList[0].ageLimitDetailInfo || item.priceFlightCabinList[0].actionCode == payload.currentActionCode) {
                                return item
                            }
                        })
                    }
                    let cacheData = response.data.inlandDetailInfos && new Array(response.data.inlandDetailInfos.length) || [];
                    context.commit("setFlightAllPriceInfo", response);
                    context.commit("setRuleInfoCache",cacheData)
                } else {
                    alert(response.msg);
                }
                //查询结束
                context.commit("setProgressSuccess", true);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.error("freeFlightList", jqXHR, textStatus, errorThrown);
                context.commit("setErrormsg", true);
                context.commit("setProgressSuccess", true);
            }
        });
    },
    //获取退改信息
    getFlightRuleInfoP(context, {parameter,currentIndex}) {
        getFlightRuleInfo && getFlightRuleInfo.abort();
        context.commit("setShowRuleInfoLoading",true);
        let result = [];
        getFlightRuleInfo = $.ajax({
            type: 'GET',
            url: host + '/api/flightInfo/getFlightRuleInfo',
            data: parameter,
            timeout: 20000,
            dataType: 'json',
            success(res) {
                if (res && res.success && res.data) {
                    result = formatRuleInfo(res.data.journeyRuleList);
                }
                context.commit("setCurrentRuleInfo",result);
                context.commit("setShowRuleInfoLoading",false);
                let cacheData = context.state.ruleInfoCache;
                cacheData[currentIndex] = result;
                context.commit("setRuleInfoCache",cacheData);
            },
            error(err) {
                context.commit("setCurrentRuleInfo",result);
                context.commit("setShowRuleInfoLoading",false);
            }
        });
    }
}
export default actions